import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const HeaderWrapper = styled.div`
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.accent} 100%);
  color: white;
  padding: 15px 25px;
  border-radius: ${({ theme }) => theme.radii.md};
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.shadows.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    gap: 15px;
  }
`;

const PlacaDisplay = styled.div`
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 2px;
`;

const DownloadButton = styled.button`
  background: white;
  color: ${({ theme }) => theme.colors.primary};
  border: none;
  padding: 10px 20px;
  border-radius: ${({ theme }) => theme.radii.sm};
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }
`;

const PlacaDisplayHeader = ({ placa, onDownload }) => (
  <HeaderWrapper>
    <PlacaDisplay>{placa}</PlacaDisplay>
    <DownloadButton onClick={onDownload}>
      <FontAwesomeIcon icon={faDownload} /> Baixar Relatório
    </DownloadButton>
  </HeaderWrapper>
);

export default PlacaDisplayHeader;